import React from 'react';
import ReactDOM from 'react-dom';
import './fonts.css';
import App from './routes/app';

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById('root')
);
